import React from 'react'

export default function Error() {
  return (
    <div>Sorry, we couldn't load that page!</div>
  )
}
